module.exports = __webpack_public_path__ + "img/ZarinPal.8034c82e.png";